import MessageBroker from "../components/message-broker";
import Messages from '../components/messages';

const windowClicked = (originalEvent) => {
    MessageBroker.publish(Messages.WINDOW.CLICKED, originalEvent);
};

MessageBroker.subscribe(Messages.INPUT_METHOD.CHANGED, (inputMethod) => {
    const { to } = inputMethod;
    const eventMapping = {
        mouse: 'click',
        touch: 'touchend'
    };
    for(const method in eventMapping) {
        const event = eventMapping[method];
        window.removeEventListener(event, windowClicked);
    }
    window.addEventListener(eventMapping[to], windowClicked);
});